import React from 'react'

const Item = ({id, stock, expeditionDate, expirationDate}) => {
  return (
    <React.Fragment>
        <span>{id}</span>
        <span>{stock}</span>
        <span>{expeditionDate}</span>
        <span>{expirationDate}</span>
    </React.Fragment>
  )
}

export default Item